import { Form, redirect } from "react-router-dom";
import "./Login.scss";
import APIConsumer from "../../APIModel";
import store from "../../store/store";
import { setToken } from "../../store/state/state";
import errorExceptionSwitch from "../../component/errorExceptionSwitch";

export async function action({ request, params }) {
  const formData = await request.formData();
  const responce = await APIConsumer.login(
    formData.get("username"),
    formData.get("password")
  );
  const url = errorExceptionSwitch(responce.status, "/");
  if (url.status) return redirect(url.url);
  store.dispatch(setToken(responce.body.token));
  return redirect("/");
}

export default function Login() {
  return (
    <div className="login">
      <Form method="post">
        <input type="text" name="username" placeholder="username" />
        <input type="text" name="password" placeholder="password" />
        <button type="submit">Login</button>
      </Form>
    </div>
  );
}
